import React from 'react';
import type { OriginCoverage } from '../../types/traffic';
interface OriginEmptyStateProps {
  coverage: OriginCoverage;
}

/**
 * Names the specific missing input rather than listing every possible cause: the
 * comparison needs BOTH an inferred region and a resolved IP country per visitor,
 * and which of the two is absent tells you what to fix.
 */
export function OriginEmptyState({
  coverage
}: OriginEmptyStateProps) {
  const {
    withOrigin,
    withCountry,
    comparable,
    matching
  } = coverage;
  if (comparable === 0) {
    const reason = withOrigin === 0 ? 'No visitor has an inferred region yet. It derives from the browser time zone, which older rows already store — run supabase/backfill.sql to fill it in retroactively.' : withCountry === 0 ? `${withOrigin.toLocaleString()} visitors have an inferred region, but none has a resolved IP country to compare it against. That is the geo lookup, which is rate-limited on free tiers — resolve geography at the edge instead.` : 'The two signals exist but never on the same visitor yet.';
    return <div className="text-xs leading-relaxed text-muted-foreground" data-id="element-294" data-mp="1b6hnd9tlsxfp">
        <p className="font-medium text-foreground" data-id="element-295" data-mp="1b8ub63m1m20o">Nothing to compare yet</p>
        <p className="mt-1.5" data-id="element-296" data-mp="1g4sx7kjwf7xx">{reason}</p>
        <p className="mt-1.5 font-mono" data-id="element-297" data-mp="1k7fuw2393n31">
          {withOrigin.toLocaleString()} with inferred region ·{' '}
          {withCountry.toLocaleString()} with IP country · {comparable.toLocaleString()} comparable
        </p>
      </div>;
  }
  return <div className="text-xs leading-relaxed text-muted-foreground" data-id="element-298" data-mp="1u40xyhvpmo48">
      <p className="font-medium text-foreground" data-id="element-299" data-mp="1yxn0vic2ndmu">No mismatches found</p>
      <p className="mt-1.5" data-id="element-300" data-mp="23vf59btwks7x">
        All {comparable.toLocaleString()} comparable visitors ({matching.toLocaleString()} matching)
        have an IP country that agrees with their browser&rsquo;s own region. Either they are not
        using a VPN, or their VPN exits in their own country — both look identical from here.
      </p>
    </div>;
}